import React from 'react';
import {
  Box,
  Container,
  Typography,
} from '@mui/material';
import AnimatedElement from './AnimatedElement';

const EventsSection = () => {
  
  // Wiederverwendbares Tabellen-Styling
  const tableStyles = {
    width: '100%',
    borderCollapse: 'collapse',
    '& td': {
      color: '#fff',
      fontSize: { xs: '0.9rem', md: '1rem' },
      padding: '8px 12px',
      borderTop: '2px solid #000',
      verticalAlign: 'top'
    },
    '& td:first-of-type': {
      fontWeight: 600,
      width: '60px',
      borderRight: '2px solid #000'
    },
    '& td:nth-of-type(2)': {
      fontWeight: 600,
      width: '60px',
      borderRight: '2px solid #000'
    },
    '& td:nth-of-type(3)': {
      fontWeight: 400
    }
  };

  return (
    <Box
      id="veranstaltungen"
      sx={{
        py: { xs: 8, md: 12 },
        bgcolor: 'primary.green'
      }}
    >


      <Container
        maxWidth={false}
        sx={{
          maxWidth: '1400px',
          pl: { xs: 2, md: 14 }, // 80px = 10 * 8px (theme spacing)
          pr: 2,
          mx: 'auto',
          mb: 8
        }}
      >
        <AnimatedElement>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '3fr 7fr 1fr' },
            gap: 2,
            alignItems: 'start'
          }}
        >
          {/* Spalte 1: Sektionsüberschrift */}
          <Box>
            <Typography
              variant="h2"
              component="h2"
              sx={{
                 fontSize: { xs: '1.6rem', sm: '1.8rem', md: '2.1rem' },
                fontWeight: 500,
                color: '#fff',
                lineHeight: 1.2,
                textAlign: 'left'
              }}
            >
              VERANSTALTUNGEN
            </Typography>
            <Box 
                                      sx={{
                                        height: '4px', 
                                        width: '100px', 
                                        backgroundColor: '#cfba80', 
                                        marginTop: { xs: '20px', sm: '30px', md: '40px' },
                                        marginBottom: '20px'
                                      }}
                                    />
          </Box>

          {/* Spalte 2: Zweispaltiger Fließtext */}
          <Box></Box>

          {/* Spalte 3: Gedrehter Text "CORPS" */}
          <Box
            sx={{
              display: { xs: 'none', md: 'flex' },
              justifyContent: 'center',
              alignItems: 'flex-start',
              height: '100%',
              minHeight: { xs: '100px', md: '400px' }
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
              <div style={{ height: '100px', width: '2px', backgroundColor: '#cfba80', marginLeft: '-4px' }}></div>
              <Typography
                variant="h3"
                sx={{
                  fontSize: { xs: '0.8rem', md: '0.9rem' },
                  fontWeight: 500,
                  color: '#fff',
                  writingMode: { xs: 'horizontal-tb', md: 'vertical-rl' },
                  textOrientation: { md: 'mixed' },
                  whiteSpace: 'nowrap',
                  letterSpacing: '0.2em',
                  textAlign: 'center',
                }}
              >
                VERANSTALTUNGEN
              </Typography>
            </div>

          </Box>
        </Box>
        </AnimatedElement>


        <AnimatedElement>
        <Box
          sx={{
            display: 'grid',
            marginTop: { xs: '0px', md: '-200px' },
            gridTemplateColumns: { xs: '1fr', md: '1fr 8fr 1fr' },
            gap: 2,
            alignItems: 'start'
          }}
        >
          {/* Spalte 1: Sektionsüberschrift */}
          <Box></Box>

          {/* Spalte 2: Zweispaltiger Fließtext */}
           <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '1fr 1fr 1fr' },
            gap: 6,
            alignItems: 'start'
          }}
        >
          <Box>
             <Typography
                variant="h3"
                sx={{
                     fontSize: { xs: '1.8rem', md: '2.1rem' },
                fontWeight: 500,
                color: 'primary.beige',
                lineHeight: 1.2,
                textAlign: 'left',
                mb: 3
                }}
              >
                Oktober
              </Typography>

              {/* Tabelle */}
              <Box
                component="table"
                sx={tableStyles}
              >
                <tbody>
                  <tr>
                    <td>21.</td>
                    <td>SA</td>
                    <td>21. Antritts cc. 18 Antrittskneipe 20 hc</td>
                  </tr>
                  <tr>
                    <td>28.</td>
                    <td>SA</td>
                    <td>Halloweenparty</td>
                  </tr>
                </tbody>
              </Box>
              
          </Box>

           <Box>
             <Typography
                variant="h3"
                sx={{
                     fontSize: { xs: '1.8rem', md: '2.1rem' },
                fontWeight: 500,
                color: 'primary.beige',
                lineHeight: 1.2,
                textAlign: 'left',
                mb: 3
                }}
              >
                November
              </Typography>

              {/* Tabelle */}
              <Box
                component="table"
                sx={tableStyles}
              >
                <tbody>
                  <tr>
                    <td>21.</td>
                    <td>SA</td>
                    <td>21. Antritts cc. 18 Antrittskneipe 20 hc</td>
                  </tr>
                  <tr>
                    <td>28.</td>
                    <td>SA</td>
                    <td>Halloweenparty</td>
                  </tr>
                </tbody>
              </Box>
              
          </Box>

           <Box>
             <Typography
                variant="h3"
                sx={{
                     fontSize: { xs: '1.8rem', md: '2.1rem' },
                fontWeight: 500,
                color: 'primary.beige',
                lineHeight: 1.2,
                textAlign: 'left',
                mb: 3
                }}
              >
                Dezember
              </Typography>

              {/* Tabelle */}
              <Box
                component="table"
                sx={tableStyles}
              >
                <tbody>
                  <tr>
                    <td>21.</td>
                    <td>SA</td>
                    <td>21. Antritts cc. 18 Antrittskneipe 20 hc</td>
                  </tr>
                  <tr>
                    <td>28.</td>
                    <td>SA</td>
                    <td>Halloweenparty</td>
                  </tr>
                </tbody>
              </Box>
              
          </Box>

           <Box>
             <Typography
                variant="h3"
                sx={{
                     fontSize: { xs: '1.8rem', md: '2.1rem' },
                fontWeight: 500,
                color: 'primary.beige',
                lineHeight: 1.2,
                textAlign: 'left',
                mb: 3
                }}
              >
                Januar
              </Typography>

              {/* Tabelle */}
              <Box
                component="table"
                sx={tableStyles}
              >
                <tbody>
                  <tr>
                    <td>21.</td>
                    <td>SA</td>
                    <td>21. Antritts cc. 18 Antrittskneipe 20 hc</td>
                  </tr>
                  <tr>
                    <td>28.</td>
                    <td>SA</td>
                    <td>Halloweenparty</td>
                  </tr>
                </tbody>
              </Box>
              
          </Box>

           <Box>
             <Typography
                variant="h3"
                sx={{
                     fontSize: { xs: '1.8rem', md: '2.1rem' },
                fontWeight: 500,
                color: 'primary.beige',
                lineHeight: 1.2,
                textAlign: 'left',
                mb: 3
                }}
              >
                Februar
              </Typography>

              {/* Tabelle */}
              <Box
                component="table"
                sx={{
                  width: '100%',
                  borderCollapse: 'collapse',
                  '& td': {
                    color: '#fff',
                    fontSize: { xs: '0.9rem', md: '1rem' },
                    padding: '8px 12px',
                    borderTop: '2px solid #000',
                    verticalAlign: 'top'
                  },
                  '& td:first-of-type': {
                    fontWeight: 600,
                    width: '60px',
                    borderRight: '2px solid #000'
                  },
                  '& td:nth-of-type(2)': {
                    fontWeight: 600,
                    width: '60px',
                    borderRight: '2px solid #000'
                  },
                  '& td:nth-of-type(3)': {
                    fontWeight: 400
                  }
                }}
              >
                <tbody>
                  <tr>
                    <td>21.</td>
                    <td>SA</td>
                    <td>21. Antritts cc. 18 Antrittskneipe 20 hc</td>
                  </tr>
                  <tr>
                    <td>28.</td>
                    <td>SA</td>
                    <td>Halloweenparty</td>
                  </tr>
                </tbody>
              </Box>
              
          </Box>

          </Box>

          {/* Spalte 3: Gedrehter Text "CORPS" */}
          <Box></Box>
        </Box>
        </AnimatedElement>



      </Container>
    </Box>
  );
};

export default EventsSection;